module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2gvnN8/tc-custom/9781423636267.jpg?1716663164273",
      "alt": "This image is the cover for the book Slow Cooker"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Slow Cooker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("From the James Beard Award–winning author of "), _c('i', [_vm._v("Slow Cooking for Two")]), _vm._v(" comes even more creative, delicious, and easy recipes for your slow cooker.")]), _c('br'), _c('br'), _vm._v(" In "), _c('i', [_vm._v("Slow Cooker Double Dinners for Two")]), _vm._v(", Cynthia Graubart expands her unique concept of using a 3-1/2- or 4-quart slow cooker coupled with slow cooker liner bags, creating two different dinners at the same time. Double dinners produce not only a tasty meal for tonight but also a wonderful second meal for later in the week or for the freezer."), _c('br'), _c('br'), _vm._v(" Enjoy diverse dishes like Chicken Marsala with Mushrooms and Sage, Rustic Mexican Stew, and Turkey Breast Tenderloin with Cranberry-Orange Sauce. Make them alongside updated traditional favorites like Red Wine Flank Steak, Old-Fashioned Pot Roast, Cherry Balsamic Pork, Vegetarian Chili, and more!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cynthia Graubart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Cynthia Stevens Graubart is an author and former television producer who began her culinary television production career with New Southern Cooking with Nathalie Dupree in 1985. She is the author of The One-Armed Cook, called the culinary version of What to Expect When You’re Expecting. Cynthia and her husband, Cliff, live in Atlanta, Georgia.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0